import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { SITE_CONTENT } from '../content';

const OrderPage = () => {
  const { orderLocations } = SITE_CONTENT.global;
  const locations = Object.keys(orderLocations);
  const [selectedCity, setSelectedCity] = useState(locations[0]);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const cityParam = params.get('city');
    if (cityParam && locations.includes(cityParam)) {
      setSelectedCity(cityParam);
    }
  }, [location, locations]);

  const currentLinks = orderLocations[selectedCity];

  return (
    <div className="rest-page bg-[#f9fafb] min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow flex items-center justify-center py-24 px-4 pt-32">
        <div className="max-w-xl w-full bg-white rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] p-8 md:p-12 text-center border border-gray-100">
          <h1 className="text-4xl md:text-5xl font-['Dancing_Script'] text-[#cd3a27] font-medium mb-2">
            Order Online
          </h1>
          
          {/* Ornamental Divider */}
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-[1.5px] w-12 bg-gradient-to-r from-transparent via-[#cd3a27] to-[#cd3a27]"></div>
            <div className="w-2 h-2 border border-[#cd3a27] rotate-45 flex items-center justify-center">
              <div className="w-1 h-1 bg-[#cd3a27]"></div>
            </div>
            <div className="h-[1.5px] w-12 bg-gradient-to-l from-transparent via-[#cd3a27] to-[#cd3a27]"></div>
          </div>

          <p className="text-gray-600 mb-8 leading-relaxed text-sm md:text-base">
            Select your city to order your favourite Seeraga Samba Biryani and Combo Boxes from our official delivery partners.
          </p>

          {/* Location Selector */}
          <div className="flex flex-wrap justify-center gap-3 mb-10">
            {locations.map((city) => (
              <button
                key={city}
                onClick={() => setSelectedCity(city)}
                className={`px-6 py-2.5 rounded-full font-bold text-sm transition-all duration-300 ${
                  selectedCity === city
                    ? 'bg-[#cd3a27] text-white shadow-md transform -translate-y-1'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {city}
              </button>
            ))}
          </div>

          {/* Delivery Links */}
          <div className="space-y-4">
            <a
              href={currentLinks.zomato}
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center gap-3 w-full py-4 rounded-lg text-white font-bold text-lg hover:opacity-90 transition-opacity transform hover:scale-[1.02]"
              style={{ backgroundColor: '#E23744' }}
            >
              Order on Zomato 🍴
            </a>
            <a
              href={currentLinks.swiggy}
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center gap-3 w-full py-4 rounded-lg text-white font-bold text-lg hover:opacity-90 transition-opacity transform hover:scale-[1.02]"
              style={{ backgroundColor: '#FC8019' }}
            >
              Order on Swiggy 🛵
            </a>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-100 flex flex-col items-center gap-2 text-xs text-gray-400">
            <div className="flex items-center gap-2 text-[#cd3a27] font-bold">
               <svg viewBox="0 0 100 100" width="16" height="16" fill="currentColor">
                  <circle cx="50" cy="50" r="45" fill="none" stroke="currentColor" strokeWidth="5"/>
                  <circle cx="50" cy="50" r="38" fill="none" stroke="currentColor" strokeWidth="2"/>
                  <text x="50" y="55" fontSize="26" fontWeight="bold" textAnchor="middle" fill="currentColor">حلال</text>
                  <text x="50" y="75" fontSize="12" fontWeight="bold" textAnchor="middle" fill="currentColor">HALAL</text>
                </svg>
                100% Halal Certified
            </div>
            <p>Delivery availability is subject to platform radius and timings.</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default OrderPage;
